export default {"src":"/_next/static/image/public/assets/icons/chevron-right.52ba5f8dd00ad83e0f63f01987384a07.svg","height":20,"width":20};